import isNil from 'lodash-es/isNil';
import { useMemo } from 'react';
import { useClient } from '../ClientProvider';
import useQuery from '../useQuery';
import useIrrigationReports from './useIrrigationReports';
function useLastIrrigationValue({ plotId, isArvalis = false, includeDripIrrigationReport, clientId }) {
    const { request: allReportsRequest, data: allReports } = useIrrigationReports({
        plotId: plotId,
        enabled: !isArvalis,
        includeDripIrrigationReport
    });
    const client = useClient();
    const irrigationAravlis = useQuery(client.waterBalanceArvalis.getIrrigations({
        clientId: clientId,
        plotId: plotId
    }), { enabled: isArvalis && !isNil(clientId) && !isNil(plotId) });
    const value = !isArvalis ? allReports?.at(0)?.value : irrigationAravlis.data?.at(0)?.dose;
    return useMemo(() => ({ isLoading: allReportsRequest.isLoading, value }), [allReportsRequest.isLoading, value]);
}
export default useLastIrrigationValue;
